import { render, staticRenderFns } from "./d-profile-bookshelf-list.vue?vue&type=template&id=89a46d1a&scoped=true&"
import script from "./d-profile-bookshelf-list.vue?vue&type=script&lang=js&"
export * from "./d-profile-bookshelf-list.vue?vue&type=script&lang=js&"
import style0 from "./d-profile-bookshelf-list.vue?vue&type=style&index=0&id=89a46d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a46d1a",
  null
  
)

export default component.exports